// Import model
import { ProjectSelectionCondition } from '../models/ProjectSelectionCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { ProjectSelectionIndexedFields } from '../models/ProjectSelectionIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { ProjectSelectionIndexedFieldsSerializer } from './ProjectSelectionIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ProjectSelectionCondition - handles JSON serialization and deserialization with type validation
 */
export class ProjectSelectionConditionSerializer {
  /**
   * Deserializes a JSON string into a ProjectSelectionCondition instance
   */
  static deserialize(json: string): ProjectSelectionCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ProjectSelectionCondition instance
   */
  static fromObject(obj: any): ProjectSelectionCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ProjectSelectionCondition');
    }


    const instance: ProjectSelectionCondition = {
      fieldName: obj['fieldName'] as ProjectSelectionIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ProjectSelectionCondition instances
   */
  static deserializeArray(json: string): ProjectSelectionCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ProjectSelectionCondition instance to a JSON string
   */
  static serialize(instance: ProjectSelectionCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ProjectSelectionCondition instance to a plain object
   */
  static toObject(instance: ProjectSelectionCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of ProjectSelectionCondition instances to a JSON string
   */
  static serializeArray(instances: ProjectSelectionCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
